export const getFilteredComponentName = (assetObj) => {
  if (!assetObj?.assetName) return;
  return assetObj?.assetName.includes('@')
    ? assetObj?.assetName.split('@')[0].trimEnd()
    : assetObj?.assetName;
};
